import React from "react";
import './footer.css';

export default () => (
  <div className="gatsby-footer">
    © {(new Date()).getFullYear()} - All Rights Reserved
  </div>
);


// WEBPACK FOOTER //
// ./src/components/footer/footer.js